import { IntlShape } from 'react-intl';

import messages from './messages';

const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;

export const formatChipDuration = (
	{ formatMessage }: Pick<IntlShape, 'formatMessage'>,
	seconds: number,
): string | undefined => {
	if (!Number.isFinite(seconds) || seconds <= 0) {
		return undefined;
	}
	if (seconds < SECONDS_PER_MINUTE) {
		return formatMessage(messages.seconds, { value: Math.floor(seconds) });
	}
	const totalMinutes = Math.round(seconds / SECONDS_PER_MINUTE);
	if (totalMinutes < MINUTES_PER_HOUR) {
		return formatMessage(messages.minutes, { value: totalMinutes });
	}
	const hours = Math.floor(totalMinutes / MINUTES_PER_HOUR);
	const minutes = totalMinutes % MINUTES_PER_HOUR;
	return minutes === 0
		? formatMessage(messages.hours, { hours })
		: formatMessage(messages.hoursAndMinutes, { hours, minutes });
};
